<template>
	<multi-tags
		v-if="tags.length > 0 && tags.indexOf('N/S') == -1"
		:tags="passedTags"
		:class-joiner="'division'"
		v-bind="options"
	/>
</template>

<script>
	import MultiTags from '@/components/MultiTags.vue';

	import multiTagsMixin from '@/mixins/multiTagsMixin.js';

	export default {
		name: "DivisionTags",
		components: {
			MultiTags
		},
		mixins: [multiTagsMixin],
		computed: {
			passedTags() {
				if (this.tags.indexOf('All') >= 0) {
					if (!this.options.showMissing) return this.allTags;
					return this.allTags.map((name) => {
						return {
							name,
							present: true
						}
					});
				}
				return this.options.showMissing ? this.tagsWithMissing : this.tags;
			}
		},
		props: {
			tags: {
				type: Array,
				required: true,
			},
			options: {
				type: Object,
				default: () => ({})
			},
		},
		beforeCreate() {
			// "N/S" and "All" are special cases so we check those separately.
			this.allTags = ["Rec", "Int", "Int/Adv", "Adv", "Open", "12U", "14U", "16U", "18U"];
		}
	}
</script>

<style lang="scss">
.multi-tag {
	&.division--Rec {
		color: midnightblue;
	}
	&.division--Int {
		color: midnightblue;
	}
	&.division--Int\/Adv {
		color: midnightblue;
	}
	&.division--Adv {
		color: midnightblue;
	}
	&.division--Open {
		color: midnightblue;
	}
}
</style>